import React, { useState } from 'react';
import {
    Button,
    Dialog,
    DialogContent,
    Checkbox,
    FormControlLabel,
    DialogTitle,
    DialogActions,
    ThemeProvider,
    Box,
    Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import vadoTheme from '../main/VadoThemeMui5'; // Import VadoTheme for mui 5

export default function PdfOptionDialog({ open, onClose }) {
    const { t } = useTranslation();

    const [options, setOptions] = useState({
        permanentStore: false,
    });

    const handleToggle = (option) => {
        setOptions((prev) => ({ ...prev, [option]: !prev[option] }));
    };

    const onConfirm = (proceed) => {
        onClose(proceed, options.permanentStore);
        // clear selection
        setOptions({ permanentStore: false });
    };

    return (
        <ThemeProvider theme={vadoTheme}>
            <Dialog open={open}>
                <DialogTitle>{t('createPdf.storePdfTitle')}</DialogTitle>
                <DialogContent>
                    <Box mb={2}>
                        <Typography variant="body2" color="textSecondary">
                            {t('createPdf.storePdfDescription')}
                        </Typography>
                    </Box>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={options.permanentStore}
                                onChange={() => handleToggle('permanentStore')}
                            />
                        }
                        label={t('createPdf.storePdf')}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => onConfirm(false)} size="small" color="secondary" variant="contained">
                        {t('buttons.cancel')}
                    </Button>
                    <Button onClick={() => onConfirm(true)} size="small" color="secondary" variant="contained">
                        {t('buttons.downloadPdf')}
                    </Button>
                </DialogActions>
            </Dialog>
        </ThemeProvider>
    );
}
